import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import Header from '../Home/Header/Header'
import Navlist from '../Home/Navlist/Navlist'
import Footer from '../Home/Footer/Footer'
import { getCatedata, getHomedata } from '../../api'
import { insert_adv, remove_adv } from '../../method/addadv'
import { iframeLoad } from '../../method/analytics'
import './Category.css'

export default function Category() {
  const [data, setData] = useState([])
  const [cate, setCate] = useState([])
  /* 获取首页数据 */
  const getHome = () => {
    getHomedata().then(res => {
      setCate(res.data.category)
    })
  }
  const { search } = useLocation()

  let cataname = search.slice(6)

  // 跳转详情
  //   const goDetails = (para) => {
  //     window.location = "/page/details?gid=" + para;
  //   };

  /* 左上角导航控制 */
  const [flag, setFlag] = useState(false)
  const top_list = () => {
    setFlag(!flag)
  }

  // 判断view是否可以滚动
  flag ? (document.getElementsByTagName('body')[0].style.overflow = 'hidden') : (document.getElementsByTagName('body')[0].style.overflow = 'auto')

  const setflag = () => {
    setFlag(false)
  }
  /* 搜索栏 */
  const [searflag, setSearchflag] = useState(false)
  const setsear = () => {
    setSearchflag(true)
  }
  /* 关闭搜索栏 */
  const setSearch = () => {
    setSearchflag(false)
  }

  useEffect(() => {
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
    //获取分类列表数据
    const getdata = () => {
      getCatedata(search).then(res => {
        // console.log(res);
        setData(res.data.list)
      })
    }
    getdata()
    getHome()

    if ((window.law_ntv_ad1, window.law_ntv_ad2)) {
      insert_adv('adv_1')
      insert_adv('adv_2')
      // 广告加载 上传分析
      var pageLoadSecond = new Date().getTime()
      iframeLoad(pageLoadSecond)

      return () => {
        remove_adv('adv_1')
        remove_adv('adv_2')
      }
    }
  }, [search])

  return (
    <div className="category4">
      <Header cataname={cataname} top_list={top_list} setsear={setsear} searflag={searflag} setSearch={setSearch} flag={flag}></Header>
      <Navlist flag={flag} setflag={setflag} gamecata={cate}></Navlist>

      <div className="cate_con">
        {/* <h2>{cataname}</h2> */}

        {/* 广告一 */}
        <div className="adv_box">
          <p>Advertisement</p>
          <div id="adv_1" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
        </div>

        <ul>
          {data?.map(item => (
            <li key={item.gid}>
              <a href={'/page/details?gid=' + item.gid} className="dis_a">
                <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                <button className="btn">{item.name}</button>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* 广告二 */}
      <div className="adv_box">
        <p>Advertisement</p>
        <div id="adv_2" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
      </div>

      {/* foot */}
      <Footer></Footer>
    </div>
  )
}
